export default function getStartTestTutomat(state) {
    return state.tutomat;
}